import { createParser, fields, compose } from '../utils/parse';
import PackagesSeo from './packagesSeo';

export const Promos = createParser('Promos', {
  link: fields.string('', { path: 'link_url' }),
  source: fields.string('', { path: 'image_src' }),
  title: fields.string('', { path: 'image_alt' }),
});

export const NavNode = createParser('NavNode', {
  id: fields.number(-1),
  promos: fields.array(Promos, { path: 'promos' }),
  slug: fields.string(''),
  title: fields.string('', { path: 'full_title' }),
  name: fields.string('', { path: 'title' }),
  type: fields.string('section'),
  color: fields.string(''),
  name: fields.string('', { path: 'title' }),
  customUrl: fields.string('', { path: 'seo_content.custom_url' }),
  childNodes: fields.array(),
  seo: fields.object(PackagesSeo, { path: 'seo_content' }),
  desktopDefaultCrossSellingTab: fields.string('', {
    path: 'desktop_default_cross_selling_tab',
  }),
  desktopFlyerCategories: fields.array(fields.string(''), {
    path: 'desktop_flyer_categories',
  }),
  mobileDefaultCrossSellingTab: fields.string('', {
    path: 'mobile_default_cross_selling_tab',
  }),
  mobileFlyerCategories: fields.array(fields.string(''), {
    path: 'mobile_flyer_categories',
  }),
});

export const CategoryNodes = createParser('ChildNodes', {
  childNodes: fields.array(NavNode, { path: 'child_nodes' }),
});

export const GroupChildren = createParser('ChildNodes', {
  childNodes: fields.array(CategoryNodes, { path: 'child_nodes' }),
});

export const GroupNodes = compose(CategoryNodes, NavNode);

export const SectionChildren = createParser('ChildNodes', {
  childNodes: fields.array(GroupNodes, { path: 'child_nodes' }),
});

export default compose(SectionChildren, NavNode);
